import { TrendArrowDown } from 'assets/svg/TrendArrowDown';
import { TrendArrowUp } from 'assets/svg/TrendArrowUp';
import { colorConstants } from 'config/colorConstants';
import { FC } from 'react';

export type TrendType = 'up' | 'down' | 'neutral';

interface TrendIndicatorProps {
    value: string | number | null;
    trendType: TrendType;
    comparisonPeriod?: string;
}

export const TrendIndicator: FC<TrendIndicatorProps> = ({
    value,
    trendType,
    comparisonPeriod,
}) => {
    const normalizedValue = value?.toString().trim();
    const isZeroValue =
        normalizedValue === '0' ||
        normalizedValue === '0%' ||
        normalizedValue === '0.0%' ||
        normalizedValue === '0.00%';
    const isMonthlyComparison = comparisonPeriod === 'month';
    const isTrendUp = trendType === 'up';
    const isTrendDown = trendType === 'down';
    const shouldShowIcon = !isZeroValue;

    const descriptionText = isMonthlyComparison ? 'from past month' : 'vs YA';

    const color = isZeroValue
        ? '#636A79'
        : isTrendUp
          ? colorConstants.seaGreen
          : colorConstants.red;
    const trendText = `${value} ${descriptionText}`;

    return (
        <div
            className="flex items-center gap-[2px]"
            style={{ color }}
        >
            {shouldShowIcon && isTrendUp && (
                <TrendArrowUp className="shrink-0" color={color} />
            )}
            {shouldShowIcon && isTrendDown && (
                <TrendArrowDown className="shrink-0" color={color} />
            )}
            <div className="font-base">{trendText}</div>
        </div>
    );
};

export default TrendIndicator;
